module.exports = __webpack_public_path__ + "img/university_background.611abcfc.jpg";